require(['jquery', 'js/glider-min'], function ($) {
const heroSliders = document.querySelectorAll(".js-hero-slider");
	const prevButton = document.querySelector('.js-hero-slider-prev');
	const nextButton = document.querySelector('.js-hero-slider-next');

//NILS
if (heroSliders) {
	heroSliders.forEach(heroSlider => {
		const glider = new Glider(heroSlider, {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: true,
			scrollLock: true,
			rewind: true,
			arrows: {
				prev: ".js-hero-slider-prev",
				next: ".js-hero-slider-next"
			},
			dots: '.js-hero-slider-bullets'
		});

		glider.isLastSlide = function() {
			return slider.page >= slider.dots.childElementCount - 1;
		}

		let autoplayDelay = 3000;

		let timeout = -1;
		let hovering = false;
		let isFocused = false;

		function startTimeout() {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				if (!hovering && !isFocused)
					glider.scrollItem((glider.slide + 1) % glider.slides.length);
			}, autoplayDelay);
		}

		let animID = 0;
		const isAnimating = () => glider.animate_id !== animID;
		const prevButton = heroSlider.closest('.c-hero-slider').querySelector('.js-hero-slider-prev');
		const nextButton = heroSlider.closest('.c-hero-slider').querySelector('.js-hero-slider-next');


		heroSlider.addEventListener('mouseover', (event) => {
			hovering = true;
			clearTimeout(timeout);
		});
		if(nextButton !== null){
			nextButton.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			nextButton.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});
		}
		if(prevButton !== null){
			prevButton.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			prevButton.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});
		}
		heroSlider.addEventListener('focusin', (event) => {
			isFocused = true;
			clearTimeout(timeout);
		});

		heroSlider.addEventListener('focusout', (event) => {
			isFocused = false;
			startTimeout();
		});

		heroSlider.addEventListener("glider-animated", function (event) {
			animID = glider.animate_id;
			if (!hovering && !isFocused) {
				startTimeout();
			}
		});


		startTimeout();
	})
}
	window.addEventListener('load', (event) => {
		function hideArrowsAndBulletsIfSingleItem() {
			if (!heroSliders) {
				return;
			}
			const heroSliderItems = document.querySelectorAll('.c-hero-slider__item');
			const arrowsElements = document.querySelectorAll('.c-hero-slider__arrows');
			const bulletsElement = document.querySelector('.c-hero-slider__bullets');

			if (heroSliderItems.length === 1) {
				arrowsElements.forEach(element => {
					element.style.display = 'none';
				});

				if (bulletsElement) {
					bulletsElement.style.display = 'none';
				}
			}
		}
		hideArrowsAndBulletsIfSingleItem();
	})

});

